export default {
    redictURL:'http%3A%2F%2F5d4pa5.natappfree.cc%2FBindProduction',
    //测试环境
    // appid: 'wxea0c40aaa6e1cf83',
    // secret: 'f88d074c0f78959d08ff21a80ab7da29'

    //生产环境
    appid: 'wx47bdcead76d8a112',
    secret: '8cc46cb42233293268f0aeab4878ba9e'
  }